export default {
  meta: {
    title: '洞察报告',
    parentPath: ['/brain'],
    breadcrumbs: {
      path: ['/brain/conversioninsight'],
      name: ['转化率洞察'],
    },
  },
};
